export const getFileTypes = () => {
  return [
    {
      label: "Image",
      value: "image",
      mimes: "image/*",
    },
    {
      label: "Video",
      value: "video",
      mimes: "video/*",
    },
    {
      label: "Audio",
      value: "audio",
      mimes: "audio/*",
    },
    {
      label: "Custom",
      value: "custom",
      mimes: [],
    },
  ];
};
